import {Component, OnInit} from '@angular/core';
import {OrderService} from "../../../services/order.service";
import {Order} from "../../../models/Order/Order";
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-customer-orders',
    templateUrl: './customer-orders.component.html',
    styleUrls: ['./customer-orders.component.css']
})
export class CustomerOrdersComponent implements OnInit {

    orders: Order[] = [];
    isLoading = true;

    constructor(
        private ordersService: OrderService , private router: Router
    ) {
    }

    ngOnInit(): void {

        this.getOrders();
    }

    getOrders() {


        this.ordersService.getCustomerOrders('all').subscribe(result => {


            this.orders = result;
            this.isLoading = false;

        });

    }

    goToOrderDetails(id) {
        this.router.navigateByUrl('order/details/' + id);


    }

}
